import styled from '@xstyled/styled-components'
import { wait, fadeIn } from '../animations'

export const SelectedDateContainer = styled.div`
  text-transform: uppercase;
  font-size: 19px;
  border-bottom-color: decoration;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  color: #fff;
  margin-top: 60px;
  width: fit-content;
  font-weight: bold;
  animation: ${wait} 0.5s linear, ${fadeIn} 1.3s ease-in-out 0.5s;
`

export const TimesContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;
  height: 145px;
  overflow: hidden;
  animation: ${wait} 0.5s linear, ${fadeIn} 1.3s ease-in-out 0.5s;
`

export const TimeIndicator = styled.div`
  cursor: pointer;
  font-weight: bold;
  color: secondary;
  font-size: 30px;
  margin: 0 20px 5px 0;
  border-bottom: 1px solid;
  border-color: transparent;
  opacity: 0.7;
  &.selected {
    border-bottom: 1px solid;
    border-color: decoration;
    color: secondary;
    opacity: 1;
  }
`
